// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"54982bbe","977":"6414e47d"}[chunkId] + ".chunk.js";
};